import React from 'react';
import PropTypes from 'prop-types';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import { GenericRadio } from 'web-ui-components/lib/data/capture';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';

// DEBTxCYBG: FieldBody always applies block field classes, That restricts
// the width of the options, meaning that it doesn't match the wireframes.

// DEBTxCYBG: FieldHeader doesn't support setting the element used to
// wrap the title, so can't use section heading. Need to confirm this is
// okay for now with design.

const Question = ({
  questionText,
  continueLabel = 'Continue',
  validationErrorMessage = 'Please select an answer',
  answers,
  selectedAnswer,
  onAnswerSelected,
  onContinue,
  hasError,
  isLoading
}) => {
  return (
    <>
      <GenericFieldWrapper
        name="question"
        title={`${questionText}:`}
        validationMessage={hasError ? validationErrorMessage : null}
      >
        <GenericRadio.StackedSet
          groupName={`question`}
          items={answers.map(({ id, answer }) => {
            return { id: id, labelText: answer };
          })}
          selectedId={selectedAnswer}
          onChange={selectedId => onAnswerSelected(selectedId)}
        />
      </GenericFieldWrapper>
      <NavigationButton.Primary
        className="u-margin-top-3"
        display="primary"
        size="md"
        width="flush"
        isLoading={isLoading}
        onClick={onContinue}
        labelText={continueLabel}
      />
    </>
  );
};

Question.propTypes = {
  continueLabel: PropTypes.string,
  validationErrorMessage: PropTypes.string,
  text: PropTypes.string.isRequired,
  answers: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      answer: PropTypes.string.isRequired
    })
  ).isRequired,
  onAnswerSelected: PropTypes.func.isRequired,
  selectedAnswer: PropTypes.string,
  onContinue: PropTypes.func.isRequired,
  hasError: PropTypes.bool.isRequired
};

export { Question };
